module.exports = __webpack_public_path__ + "022781cb4e8b77b064324b93f9f61da5.svg";